import { Button, Stack, Text } from 'src/design-system/ui'
import { useBusinessPortal } from 'src/layouts/BusinessPortalLayout/useBusinessPortal'

export const PortalWorkspaceEmptyState = ({
  onChooseWorkspace,
}: {
  onChooseWorkspace?: () => void
}) => {
  const { pmNames, pmNamesLoading } = useBusinessPortal()
  const hasWorkspaces = pmNames.length > 0
  return (
    <div className="ds:flex ds:min-h-full ds:items-center ds:justify-center ds:p-6 ds:text-center">
      <Stack gap="tight" className="ds:items-center ds:max-w-lg">
        <Text as="h1" variant="section-title">
          {pmNamesLoading
            ? 'Loading workspaces…'
            : hasWorkspaces
              ? 'Select a workspace'
              : 'No workspace available'}
        </Text>
        <Text tone="muted">
          {pmNamesLoading
            ? 'Your available property managers will appear shortly.'
            : hasWorkspaces
              ? 'Choose a property manager from the navigation to view its portal.'
              : 'Your account has no portal workspace available. Contact your workspace administrator for access.'}
        </Text>
        {!pmNamesLoading && hasWorkspaces && onChooseWorkspace && (
          <Button variant="secondary" onPress={onChooseWorkspace}>
            Choose workspace
          </Button>
        )}
      </Stack>
    </div>
  )
}
